import { useEffect, useState } from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import useFetch from "../hooks/useFetch";
import QuoteBox from "./QuoteBox";
import ButtonBox from "./ButtonBox";
import Footer from "./Footer";
import randomFunction from "../helpers";
import Handlee from "../fonts/Handlee/Handlee-Regular.ttf";
import Nunito from "../fonts/Nunito/Nunito-Regular.ttf";

const url = `https://gist.githubusercontent.com/camperbot/5a022b72e96c4c9585c32bf6a75f62d9/raw/e3c6895ce42069f0ee7e991229064f167fe8ccdc/quotes.json`;

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  @font-face {
    font-family: Handlee;
    src: url(${Handlee});
  }

  @font-face {
    font-family: Nunito;
    src: url(${Nunito});
  }

  html, body {
    margin:0;
    padding:0;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

const OuterBox = styled.div`
  min-height: 100vh;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items: center;
  background-color: ${props => props.theme.color};
  transition: background-color 0.75s ease-out;
`;

const InnerBox = styled.div`
  width: 600px;
  min-height: 200px;
  border-radius: 3px;
  padding: 40px 50px;
  background: ${props => props.theme.textcolor};
`;

const theme = {
  color: `${randomFunction()}`,
  textcolor: "#fff",
}

const App = () => {

  const apiData = useFetch(url);
  const [currentQuote, setCurrentQuote] = useState({ quote: null, author: null });

  useEffect(() => {
    const newQuote = randomFunction(apiData);
    if(!newQuote) return;
    setCurrentQuote(newQuote);
  }, [apiData]);

  const getNewQuote = () => {
    const newQuote = randomFunction(apiData);
    if (!newQuote) return;
    setCurrentQuote(newQuote);
    theme.color = randomFunction();
  };

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <OuterBox>
          <InnerBox>
            <QuoteBox currentQuote={currentQuote} />
            <ButtonBox currentQuote={currentQuote} getNewQuote={getNewQuote} />
          </InnerBox>
          <Footer />
        </OuterBox>
      </ThemeProvider>
    </>
  );
};

export default App;